import { render } from "./VFormGroupTextarea.vue?vue&type=template&id=5563091c&scoped=true&ts=true"
import script from "./VFormGroupTextarea.vue?vue&type=script&lang=ts"
export * from "./VFormGroupTextarea.vue?vue&type=script&lang=ts"

import "./VFormGroupTextarea.vue?vue&type=style&index=0&id=5563091c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5563091c"]])

export default __exports__